module.exports = __webpack_public_path__ + "img/thumbnail_GoliathFrog_u_normal.82fa7718.png";